import { getAuth0Client } from '~auth';
import { router } from '../index';

export const protectRoute = async () => {
  const auth0 = await getAuth0Client();
  const isAuthenticated = await auth0.isAuthenticated();
  if (!isAuthenticated) {
    const lastResolvedRoutes = router.lastResolved();
    localStorage.setItem('authRedirect', JSON.stringify(lastResolvedRoutes[0]));
    router.navigate('/login');
    return;
  }
};
